import Vue from 'vue'
import Big from 'big.js';
import { MessageBox } from 'element-ui'

const utils = {
    hasString(sourceStr, strArr) {
        if (typeof(sourceStr) !== 'string') {
            return false
        }
        let hasStr = false
        for (const key in strArr) {
            if (sourceStr.indexOf(strArr[key]) > -1) hasStr = true
        }
        return hasStr
    },
    getQueryVariable: (url, variable) => {
        var query = url ? url.search.substring(1) : window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    pointToYuan(money) {
        if (money) {
            window.big = Big
            return new Big(money).div(100).toString()
        } else {
            return 0
        }
    },
    alertMessage(content = '内容', title = '提示') {
        MessageBox.alert(content, title, {
            confirmButtonText: '确定',
            callback: action => {
                
            }
        })
    }
}


for (const key in utils) {
    Vue.prototype[key] = utils[key]
}


export default utils